import { render, staticRenderFns } from "./BackProduct.vue?vue&type=template&id=1e2ea2ca&scoped=true"
import script from "./BackProduct.vue?vue&type=script&lang=js"
export * from "./BackProduct.vue?vue&type=script&lang=js"
import style0 from "./BackProduct.vue?vue&type=style&index=0&id=1e2ea2ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e2ea2ca",
  null
  
)

export default component.exports